(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[97706],{

/***/ 62916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.t = function FaFacebookF (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"}}]})(props);
};


/***/ }),

/***/ 80681:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.Z = function FaInstagram (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"}}]})(props);
};


/***/ }),

/***/ 31362:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.f = function FaTwitter (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"}}]})(props);
};


/***/ }),

/***/ 18320:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.V = function FaYoutube (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"}}]})(props);
};


/***/ }),

/***/ 97706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _react_icons_all_files_fa_FaFacebookF__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62916);
/* harmony import */ var _react_icons_all_files_fa_FaInstagram__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80681);
/* harmony import */ var _react_icons_all_files_fa_FaTwitter__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31362);
/* harmony import */ var _react_icons_all_files_fa_FaYoutube__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18320);
/* harmony import */ var _ImageLoader__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71700);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);












var Loading = function() {
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex gap-x-24",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "font-semibold text-xl leading-9 text-brand-black mb-3 inline-block",
                                children: /*#__PURE__*/ _jsx(Skeleton, {
                                    width: 100,
                                    height: 40
                                })
                            }),
                            /*#__PURE__*/ _jsx(Skeleton, {
                                count: "10"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "font-semibold text-xl leading-9 text-brand-black mb-3 inline-block",
                                children: /*#__PURE__*/ _jsx(Skeleton, {
                                    width: 100,
                                    height: 40
                                })
                            }),
                            /*#__PURE__*/ _jsx(Skeleton, {
                                count: "10"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "font-semibold text-xl leading-9 text-brand-black mb-3 inline-block",
                                children: /*#__PURE__*/ _jsx(Skeleton, {
                                    width: 100,
                                    height: 40
                                })
                            }),
                            /*#__PURE__*/ _jsx(Skeleton, {
                                count: "10"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex flex-col gap-y-3",
                        children: [
                            /*#__PURE__*/ _jsx(Skeleton, {
                                count: 1,
                                width: 150,
                                height: 40
                            }),
                            /*#__PURE__*/ _jsx(Skeleton, {
                                count: 1,
                                width: 150,
                                height: 40
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex gap-x-3 mt-20",
                children: [
                    /*#__PURE__*/ _jsx(Skeleton, {
                        count: 1,
                        width: 150,
                        height: 40
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        count: 1,
                        width: 150,
                        height: 40
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "mt-auto flex py-12 border-t gap-x-16",
                children: [
                    /*#__PURE__*/ _jsx(Skeleton, {
                        count: 1,
                        width: 150
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        count: 1,
                        width: 150
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        count: 1,
                        width: 150
                    })
                ]
            })
        ]
    });
};
//TODO: Menu content her render olduğunda datayı tekrar çekiyor.kontrol et
var MenuContent = function(param) {
    var data = param.data, MenuIsOpen = param.MenuIsOpen;
    var items = data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "fixed top-24 left-0 w-full z-[9999] bg-brand-gray-5 transform transition-all duration-300 shadow-lg " + (MenuIsOpen ? "block" : "hidden "),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "container pt-10 xl:pt-32 flex justify-between w-full",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-col w-full",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex gap-x-24 justify-between xl:justify-start ",
                            children: [
                                items.menu && items.menu.map(function(item) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "font-semibold text-xl leading-9 text-brand-black mb-3 inline-block",
                                                children: item.name
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                className: "text-brand-black text-sm gap-y-2 flex flex-col",
                                                children: item.items && item.items.map(function(item) {
                                                    var a = {};
                                                    if (item.nofollow == "0") a.rel = "nofollow";
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                            href: item.url,
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                                                                className: "leading-10 opacity-70 transition-opacity hover:opacity-100"
                                                            }, a), {
                                                                children: item.name
                                                            }))
                                                        })
                                                    }, item.id);
                                                })
                                            })
                                        ]
                                    }, item.id);
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex flex-col gap-y-3",
                                    children: [
                                        items.mainContent && items.mainContent.map(function(item) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                href: item.url,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    title: item.title,
                                                    className: "font-semibold text-xl leading-9 text-brand-black inline-block",
                                                    children: item.name
                                                })
                                            }, item.id);
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex gap-x-3",
                                            children: [
                                                items.social.facebook && items.social.facebook !== "" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                    href: items.social.facebook,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        target: "_blank",
                                                        rel: "nofollow",
                                                        className: "bg-white rounded-full w-9 h-9 flex items-center justify-center text-brand-gray-6 shadow-search",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_fa_FaFacebookF__WEBPACK_IMPORTED_MODULE_6__/* .FaFacebookF */ .t, {})
                                                    })
                                                }) : "",
                                                items.social.twitter && items.social.twitter !== "" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                    href: items.social.twitter,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        target: "_blank",
                                                        rel: "nofollow",
                                                        className: "bg-white rounded-full w-9 h-9 flex items-center justify-center text-brand-gray-6 shadow-search",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_fa_FaTwitter__WEBPACK_IMPORTED_MODULE_7__/* .FaTwitter */ .f, {})
                                                    })
                                                }) : "",
                                                items.social.instagram && items.social.instagram !== "" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                    href: items.social.instagram,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        target: "_blank",
                                                        rel: "nofollow",
                                                        className: "bg-white rounded-full w-9 h-9 flex items-center justify-center text-brand-gray-6 shadow-search",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_fa_FaInstagram__WEBPACK_IMPORTED_MODULE_8__/* .FaInstagram */ .Z, {})
                                                    })
                                                }) : "",
                                                items.social.youtube && items.social.youtube !== "" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                    href: items.social.youtube,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        target: "_blank",
                                                        rel: "nofollow",
                                                        className: "bg-white rounded-full w-9 h-9 flex items-center justify-center text-brand-gray-6 shadow-search",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_fa_FaYoutube__WEBPACK_IMPORTED_MODULE_9__/* .FaYoutube */ .V, {})
                                                    })
                                                }) : ""
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex gap-x-3 mt-5 xl:mt-20 mb-2",
                            children: items.links && items.links.map(function(item) {
                                var a = {};
                                a.rel = "nofollow";
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                    href: item.url,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                                        title: item.title
                                    }, a), {
                                        className: "p-5 rounded-t-sm font-bold text-tiny tracking-1 transition-transform transform hover:scale-10 " + (item.primary === "1" ? "bg-brand-color-primary text-white" : "bg-white text-black"),
                                        children: item.name
                                    }))
                                }, item.id);
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mt-auto flex py-12 border-t gap-x-16",
                            children: items.footerMenu && items.footerMenu.map(function(item) {
                                var a = {};
                                if (item.nofollow == "0") a.rel = "nofollow";
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                    href: item.url,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                                        title: item.title
                                    }, a), {
                                        className: "text-brand-black text-tiny leading-9 font-semibold",
                                        children: item.name
                                    }))
                                }, item.id);
                            })
                        })
                    ]
                }),
                 true ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "hidden xl:block",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "max-w-full",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: "/icons/menu-right.jpg",
                            width: "398",
                            height: "857",
                            alt: "Men\xfc resim",
                            loader: _ImageLoader__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z
                        })
                    })
                }) : 0
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (MenuContent);


/***/ }),

/***/ 71700:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var Local = function(param) {
    var src = param.src, width = param.width, quality = param.quality;
    return "".concat(src, "?quality=").concat(quality || 75);
};
/* harmony default export */ __webpack_exports__["Z"] = (Local);


/***/ }),

/***/ 69396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ })

}]);